import {toSignal} from '@angular/core/rxjs-interop';
import {inject, Signal} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {distinctUntilChanged, map} from 'rxjs/operators';
import {coerceNumberProperty} from '@angular/cdk/coercion';

export function param(name: string): Signal<string> {
  return toSignal(
    inject(ActivatedRoute)
      .params
      .pipe(
        map(params => params[name]),
        distinctUntilChanged()
      )
  );
}

export function numberParam(name: string, fallback = 0): Signal<number> {
  return toSignal(
    inject(ActivatedRoute)
      .params
      .pipe(
        map(params => coerceNumberProperty(params[name], fallback)),
        distinctUntilChanged()
      )
  );
}
